//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const ajax = require("../../util/ajax");
const Lerc = require("lerc");
const RasterTileSource = require("../../source/raster_tile_source");

class LercTileMaskSource extends RasterTileSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        const defaultFun = (v) => (v > 0 && v <= 1);
        this.maskFun = this._options.maskFun || defaultFun;
        if (typeof this.maskFun !== 'function') {
            throw new Error('maskFun require function');
        }
    }
    loadTile(tile, callback) {
        const url = this.map._requestManager.normalizeTileURL(
            tile.tileID.canonical.url(this.tiles, this.scheme),
            this.url,
            this.tileSize
        );

        // const url = this.setArcgisUrl(tile);
        tile.request = ajax.getArrayBuffer(url, done.bind(this));

        function done(err, img) {
            delete tile.request;

            if (tile.aborted) {
                this.state = "unloaded";
                return callback(null);
            }

            if (err) {
                this.state = "errored";
                return callback(err);
            }

            if (!this.verifyLerc(img.data)) {
                this.state = "errored";
                return callback("æ°æ®ä¸å­å¨");
            }

            if (this.map._refreshExpiredTiles) tile.setExpiryData(img);
            delete img.cacheControl;
            delete img.expires;
            //è§£ælercæ°æ®
            const lerc = Lerc.decode(img.data);

            // const lercdata = lerc.pixels[0].map(v => (this.maskFun(v) ? 1 : 0));
            const lercdata = lerc.pixels[0];
            const gl = this.map.painter.context.gl;
            const floatTextures = gl.getExtension('OES_texture_float');
            if (!floatTextures) {
                console.error('no floating point texture support');
                return;
            }
            // tile.texture = this.map.painter.getTileTexture(lerc.width);
            // if (tile.texture) {
            //     gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            //     gl.texSubImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, lerc.width, lerc.height, 0, gl.LUMINANCE, gl.FLOAT, new Float32Array(lercdata));
            // } else {
            // æ­¤å¤ä¸è½ç¨åä»painteréååºä¹åäº§çè¿ç texture å¯¹è±¡äº
            // å ä¸ºè¿éç texture å¨ gl.texImage2Dæ¶ internalformat åæ°è®¾ä¸ºäº gl.LUMINANCE
            // èè¿ä¸ªåæ°å¨ texSubImage2D éæ¯æ æ³ä¿®æ¹çï¼ä¼å¯¼è´å²çª
            tile.texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, lerc.width, lerc.height, 0, gl.LUMINANCE, gl.FLOAT, new Float32Array(lercdata));

            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            if (this.map.painter.extTextureFilterAnisotropic) {
                gl.texParameterf(gl.TEXTURE_2D, this.map.painter.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.map.painter.extTextureFilterAnisotropicMax);
            }
            tile.texture.size = lerc.width;
            // }
            gl.generateMipmap(gl.TEXTURE_2D);
            tile.state = "loaded";
            callback(null);
        }
    }
    verifyLerc(data, options) {
        options = options || {};
        const inputOffset = options.inputOffset || 0;
        const fileIdView = new Uint8Array(data, inputOffset, 10);
        const fileIdentifierString = String.fromCharCode.apply(null, fileIdView);
        if (
            fileIdentifierString.trim() === "CntZImage" ||
            fileIdentifierString.substring(0, 5) === "Lerc2"
        )
            return true;
        else return false;
    }
    ndviColor(value) {
        const palette = {
            thresholds: [
                0,
                0.03,
                0.07,
                0.1,
                0.13,
                0.17,
                0.2,
                0.25,
                0.3,
                0.35,
                0.4,
                0.45,
                0.5,
                0.6,
                0.7,
                0.8,
                0.9
            ],
            colors: [
                "#000000",
                "#FFFFFF",
                "#c4baa4",
                "#b4966c",
                "#a4824c",
                "#94723c",
                "#7c9e2c",
                "#94b614",
                "#74aa04",
                "#64a204",
                "#549604",
                "#3c8604",
                "#1c7204",
                "#045e04",
                "#044204",
                "#043a04",
                "#042604",
                "#041204"
            ]
        };
        if (value <= 0 || value > 1) value = 0;
        function getIndex(value) {
            for (let i = 0; i < palette.thresholds.length; i++) {
                if (value < palette.thresholds[i]) return i;
            }
        }
        function convertHex(hex) {
            if (hex === undefined) {
                return [0, 0, 0, 0];
            }
            hex = hex.replace("#", "");
            const r = parseInt(hex.substring(0, 2), 16),
                g = parseInt(hex.substring(2, 4), 16),
                b = parseInt(hex.substring(4, 6), 16);

            return [r, g, b, 256];
        }
        return convertHex(palette.colors[getIndex(value)]);
    }
    setArcgisUrl(tile) {
        let z = tile.tileID.canonical.z,
            y = tile.tileID.canonical.y.toString(16),
            x = tile.tileID.canonical.x.toString(16);
        if (z < 10) z = `0${z}`;
        const rLength = y.length; // row è¡å·

        if (rLength < 8) {
            for (let i = 0; i < 8 - rLength; i++) {
                y = `0${y}`;
            }
        }
        const r = `R${y}`;
        const cLength = x.length;
        if (cLength < 8) {
            for (let i = 0; i < 8 - cLength; i++) {
                x = `0${x}`;
            }
        }
        const c = `C${x}`;// æ ¹
        const url = `http://101.201.77.235:8080/L${z}/${r}/${c}.lerc`;
        return url;
    }
    unloadTile(tile) {
        if (tile.texture) this.map.painter.context.gl.deleteTexture(tile.texture);
    }
}

module.exports = LercTileMaskSource;
